export default "__VITE_ASSET__78c90464__"